import React from "react";
import { motion } from "framer-motion";
import { aboutUsImage, aboutUsBg, ourVisionImage, ourMissionImage } from "../assets/Images";

//cspell: ignore NBFCs Subramaniam

const AboutUs = () => {
  return (
    <div>
      <div className="relative pt-12 pb-8 lg:py-16 px-4 sm:px-6 overflow-hidden mt-16 lg:mt-24 container mx-auto">
        <section className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center relative gap-2 lg:gap-0 overflow-hidden">
          {/* LEFT: Image - Full width on mobile and md, 50% on lg+ */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative z-20 w-full lg:w-1/2 order-2 lg:order-1 hidden lg:block"
          >
            <img
              src={aboutUsImage}
              alt="About Us"
              className="w-full h-auto max-h-[500px] md:max-h-[500px] lg:max-h-[400px] xl:max-h-[470px] object-fill lg:object-contain xl:object-fill rounded-2xl "
            />
          </motion.div>

          {/* RIGHT: Shaped Background with Content - Full width on mobile/md, overlaps on lg+ */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative w-full lg:w-[75%] xl:w-[80%] h-[350px] md:h-[400px] lg:h-[500px] xl:h-[600px] mt-0 lg:-ml-40 xl:-ml-64 order-1 lg:order-2 hidden lg:block"
          >
            {/* Shape Background */}
            <img
              src={aboutUsBg}
              alt="Shape Background"
              className="absolute inset-0 w-full h-full object-fill"
            />

            {/* Content over Shape */}
            <div className="relative z-10 h-full flex flex-col justify-center items-center p-6 sm:p-8 lg:p-10 xl:p-12">
              <h2 className="text-3xl lg:text-4xl font-bold mb-4 text-black text-center md:text-left lg:ml-24 xl:ml-44 font-sans">
                About Us
              </h2>
              <p className="text-base lg:text-lg text-black leading-relaxed lg:leading-loose text-left lg:ml-36 xl:ml-60 max-w-md lg:max-w-lg font-sans">
                At Subramaniam Financial Services, we take pride in being a <strong>trusted channel partner </strong>
                with over <strong>25 years of experience</strong> in the financial sector.
                As a <strong>Direct Selling Agent (DSA)</strong> for leading <strong>banks and NBFCs</strong>, we specialize
                in delivering ethical, transparent, and reliable financial solutions
                to our customers' needs.
              </p>
            </div>
          </motion.div>
          {/* <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative w-full lg:w-[75%] xl:w-[80%] h-[350px] md:h-[400px] lg:h-[500px] xl:h-[600px] mt-0 lg:-ml-40 xl:-ml-64 order-1 lg:order-2 lg:hidden"
          >
 
            <img
              src={aboutUsBgWithContent}
              alt="Shape Background"
              className="absolute inset-0 w-full h-full object-fill"
            />
          </motion.div> */}

          {/* Mobile Screen and Tablet Screen */}
          {/* <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative z-20 w-full lg:w-1/2 order-2 lg:order-1 lg:hidden"
          >
            <img
              src={aboutUsMobile}
              alt="About Us"
              className="w-full h-auto max-h-[500px] md:max-h-[500px] lg:max-h-[400px] xl:max-h-[470px] object-fill lg:object-contain xl:object-fill rounded-2xl "
            />
          </motion.div> */}

            <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative w-full mt-0 bg-[#E8E6FD] rounded-2xl order-1 lg:order-2 lg:hidden"
          >
            {/* Content over Shape */}
            <div className=" h-full flex flex-col justify-center items-center p-6 sm:p-8 lg:p-10 xl:p-12">
              <h2 className="text-3xl lg:text-4xl font-bold mb-4 text-black text-center md:text-left lg:ml-24 xl:ml-44 font-sans">
                About Us
              </h2>
              <p className="text-base lg:text-lg text-black leading-relaxed lg:leading-loose text-left lg:ml-36 xl:ml-60 max-w-2xl font-sans">
                At Subramaniam Financial Services, we take pride in being a <strong>trusted channel partner </strong>
                with over <strong>25 years of experience</strong> in the financial sector.
                As a <strong>Direct Selling Agent (DSA)</strong> for leading <strong>banks and NBFCs</strong>, we specialize
                in delivering ethical, transparent, and reliable financial solutions
                to our customers' needs.
              </p>
            </div>
          </motion.div>
            
        </section>
      </div>


      <div className="bg-[#F7FFF6] pt-6">
        {/* Our Mission */}
        <section className="px-4 sm:px-6 container mx-auto overflow-hidden">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:justify-between items-center lg:gap-4">
            {/* LEFT: Image */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="w-full md:w-1/2 flex justify-center order-2 md:order-1"
            >
              <img
                src={ourMissionImage}
                alt="Our Mission"
                className="w-full h-auto max-h-[300px] object-contain"
              />
            </motion.div>

            {/* RIGHT: Content */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="w-full md:w-1/2 text-left order-1 md:order-2"
            >
              <h2 className="text-3xl lg:text-4xl font-bold mb-4 md:mb-8 text-black text-center">Our Mission</h2>
              <p className="text-base lg:text-lg text-black leading-relaxed">
                To guide individuals and businesses with professional financial advice and help them secure the right loan products with ease and confidence. With a client-centric approach, we serve customers from all walks of life, ensuring personalized service and seamless loan processing.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Our Vision */}
        <section className="px-4 sm:px-6 container mx-auto overflow-hidden">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:justify-between items-center lg:gap-4">
            {/* LEFT: Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="w-full md:w-1/2 text-left"
            >
              <h2 className="text-3xl lg:text-4xl font-bold mb-4 md:mb-8 text-black text-center">Our Vision</h2>
              <p className="text-base lg:text-lg text-black leading-relaxed">
                To become the most trusted and accessible financial partner for individuals and businesses across India by delivering ethical, transparent, and personalized financial solutions that empower every customer to achieve their goals and dreams.
              </p>
            </motion.div>

            {/* RIGHT: Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="w-full md:w-1/2 flex justify-center"
            >
              <img
                src={ourVisionImage}
                alt="Our Vision"
                className="w-full h-auto max-h-[300px] object-contain"
              />
            </motion.div>
          </div>
        </section>

        <section className="bg-[#1E4D91] text-white py-12  px-4 sm:px-6 ">
          <p className="max-w-7xl mx-auto text-[20px] lg:text-[30px] xl:text-[40px] line-height font-bold text-center">At Subramaniam Financial Services, your financial growth is our priority. Let us help you find the best loan solution with speed, simplicity, and integrity.</p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;